export default "__VITE_ASSET__B_uuE4kk__"